import dayjs from "dayjs";

export const requestEventFormSettings = [
    {
        col: { span: 24 },
        label: "Intake Information",
        type: "divider"
    },
    {
        col: { span: 24, lg: 12 },
        form: {
            label: "Requester First Name",
            name: ["intakeInformation", "firstName"],
            rules: []
        },
        required: true,
        placeholder: "Please input requester first name",
        type: "text",
    },
    {
        col: { span: 24, lg: 12 },
        form: {
            label: "Requester Last Name",
            name: ["intakeInformation", "lastName"],
            rules: []
        },
        required: true,
        placeholder: "Please input requester last name",
        type: "text",
    },
    {
        col: { span: 24 },
        form: {
            label: "Requesting Center(s)",
            name: ["intakeInformation", "requestCenter"],
            rules: []
        },
        required: true,
        placeholder: "Please select requesting center",
        type: "select-center",
    },
    {
        col: { span: 24 },
        form: {
            label: "Total Contract Amount",
            name: ["intakeInformation", "totalContractAmount"],
            rules: []
        },
        required: true,
        placeholder: "Please input total contract amount",
        type: "money",
    },
    {
        col: { span: 24 },
        form: {
            label: "Payment term",
            name: ["intakeInformation", "paymentTerm"],
            rules: []
        },
        placeholder: "Please select payment term",
        required: true,
        options: [
            { label: "Monthly", value: "Monthly" },
            { label: "One-Time", value: "One-Time" },
            { label: "Other", value: "Other" },
        ],
        subForm: {
            onRender: (value) => {
                if (value !== "Other") return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Payment term detail",
                        name: ["intakeInformation", "paymentTermDetail"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please detail about payment term",
                    type: "text",
                }];
            }
        },
        type: "select",
    },
    {
        col: { span: 24 },
        form: {
            label: "Was this request approved by your AD/SM?",
            name: ["intakeInformation", "approvedByAdmin"],
            rules: []
        },
        required: true,
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        subForm: {
            onRender: (value) => {
                if (!value) return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Your AD/SM name",
                        name: ["intakeInformation", "approvedByAdminName"],
                        rules: []
                    },
                    required: true,
                    type: "text",
                }];
            }
        },
        bottomTitle: {
            onShowBottom: (value) => {
                if (value === false) {
                    return <div className="mt-2">Please present this opportunity to your AD/SM for approval prior to submission.</div>
                }
                return;
            }
        },
        type: "radio",
    },
    {
        col: { span: 24 },
        label: "Vendor and Event Information",
        type: "divider"
    },
    {
        col: { span: 24 },
        form: {
            label: "Name of organization",
            name: ["vendorSection", "organizationName"],
            rules: []
        },
        required: true,
        placeholder: "Please input name of organization",
        type: "text",
    },
    {
        col: { span: 24 },
        form: {
            label: "Name of Vendor Contact",
            name: ["vendorSection", "vendorName"],
            rules: []
        },
        required: true,
        placeholder: "Please input name of vendor contact",
        type: "text",
    },
    {
        col: { span: 24 },
        form: {
            label: "Vendor Email",
            name: ["vendorSection", "vendorEmail"],
            rules: [
                {
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Please enter a valid email!'
                }
            ]
        },
        required: true,
        placeholder: "Please input vendor email",
        type: "text",
    },
    {
        col: { span: 24 },
        form: {
            label: "Vendor Phone",
            name: ["vendorSection", "vendorPhone"],
            rules: []
        },
        inputForm: {
            label: "Vendor Phone",
            name: ["vendorSection", "vendorPhone", "phone"],
            rules: [
                {
                    pattern: new RegExp(/^[0-9]{9,10}$/),
                    message: "Phone number should be 9 or 10 digits",
                },
            ]
        },
        selectForm: {
            label: "Vendor Phone",
            name: ["vendorSection", "vendorPhone", "zipCode"],
            rules: []
        },
        required: true,
        placeholder: "Please input vendor phone",
        type: "phone",
    },
    {
        col: { span: 24 },
        form: {
            label: "Is the vendor in Ariba?",
            name: ["vendorSection", "inAriba"],
            rules: []
        },
        required: true,
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        bottomTitle: {
            onShowBottom: (value) => {
                if (value === false) {
                    return <div className="mt-2">Please contact your field marketing manager to complete the necessary contract documentation found on the Marketing iNet page.</div>
                }
                return;
            }
        },
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Payment term: Net-30",
            name: ["vendorSection", "agreeVendorPaymentTerm"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Does your contract require a Certificate of Insurance?",
            name: ["vendorSection", "coiRequire"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        bottomTitle: {
            onShowBottom: (value) => {
                if (!value) {
                    return;
                }
                return <a href="https://cslpromise.sharepoint.com/sites/inet-legal?CT=1743616021832&OR=OWA-NT-Mail&CID=923702b3-6874-76a5-d685-e7be06979c71#/sitepages/insurance.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="red-link"
                >
                    <div className="truncate">
                        Please click here to access Certificate of Insurance documentation.
                    </div>
                </a>
            }
        },
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Target demographic",
            name: ["vendorSection", "targetDemographic"],
            rules: []
        },
        options: [
            { label: "Community", value: "Community" },
            { label: "College", value: "College" },
            { label: "Military", value: "Military" },
            { label: "Merchant Partnership", value: "Merchant Partnership" },
            { label: "Bilingual", value: "Bilingual" },
            { label: "Other", value: "Other" },
        ],
        subForm: {
            onRender: (value) => {
                if (value !== "Other") return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Description",
                        name: ["vendorSection", "targetDemographicDescription"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please provide description",
                    type: "textarea",
                }];
            }
        },
        placeholder: "Please select target demographic",
        required: true,
        type: "select",
    },
    {
        col: { span: 24 },
        form: {
            label: "Event Subject",
            name: ["vendorSection", "eventSubject"],
            rules: []
        },
        options: [
            { label: "Exhibits and Conventions", value: "Exhibits and Conventions" },
            { label: "Media Placement", value: "Media Placement" },
            { label: "Promotional Gifts", value: "Promotional Gifts" },
        ],
        placeholder: "Please select Event Subject",
        required: true,
        type: "select",
    },
    {
        col: { span: 24 },
        form: {
            label: "Location event: (Town/City, State)",
            name: ["vendorSection", "eventLocation"],
            rules: []
        },
        required: true,
        placeholder: "Please input Town/City, State",
        type: "text",
    },
    {
        col: { span: 24 },
        form: {
            label: "Activity start date",
            name: ["vendorSection", "eventStartDate"],
            rules: []
        },
        inputProps: {
            disabledDate: (current, dependenciesFieldValue) => {
                return current && dependenciesFieldValue && current > dependenciesFieldValue.startOf("day");
            },
        },
        dependenciesField: {
            key: ["vendorSection", "eventEndDate"],
        },
        required: true,
        placeholder: "Activity start date",
        type: "date",
    },
    {
        col: { span: 24 },
        form: {
            label: "Activity end date",
            name: ["vendorSection", "eventEndDate"],
            rules: []
        },
        dependenciesField: {
            key: ["vendorSection", "eventStartDate"],
        },
        inputProps: {
            disabledDate: (current, dependenciesFieldValue) => {
                return current && dependenciesFieldValue && current < dependenciesFieldValue.startOf("day")
            },
        },
        required: true,
        placeholder: "Activity end date",
        type: "date",
    },
    {
        col: { span: 24 },
        form: {
            label: "Estimated attendee count",
            name: ["vendorSection", "estimatedAttendeeCount"],
            rules: []
        },
        required: true,
        placeholder: "Please input estimated attendee count",
        type: "number",
    },
    {
        col: { span: 24 },
        form: {
            label: "Target Age Range",
            name: ["vendorSection", "targetAge"],
            rules: []
        },
        options: [
            { label: "18-25", value: "18-25" },
            { label: "26-46", value: "26-46" },
            { label: "47+", value: "47+" },
            { label: "All", value: "All" },
        ],
        required: true,
        placeholder: "Please select Target Age Range",
        type: "select",
    },
    {
        col: { span: 24 },
        form: {
            label: "Is the sponsorship opportunity for other business units to participate? E.g. Behring, Vifor, Sequirus",
            name: ["vendorSection", "otherBusinessUnitsToParticipate"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Organization type (Tax-exempt org (i.e. 501 (c)(3)) OR for-profit organization)",
            name: ["vendorSection", "organizationType"],
            rules: []
        },
        options: [
            { label: "Tax-exempt", value: "Tax-exempt" },
            { label: "For-profit", value: "For-profit" },
        ],
        subForm: {
            onRender: (value) => {
                if (value !== "Tax-exempt") return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Is this a Foundation?",
                        name: ["vendorSection", "isFoundation"],
                        rules: []
                    },
                    options: [
                        { label: "Yes", value: true },
                        { label: "No", value: false },
                    ],
                    required: true,
                    type: "radio",
                },];
            }
        },
        required: true,
        placeholder: "Please select organization type",
        type: "select",
    },
    {
        col: { span: 24 },
        form: {
            label: "Exhibit booth/Table",
            name: ["vendorSection", "benefit", "exhibitBooth", "answer"],
            rules: [],
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        subForm: {
            onRender: (value) => {
                if (!value) return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Event Name",
                        name: ["vendorSection", "benefit", "exhibitBooth", "eventName"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please input event name",
                    type: "text",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Event Name (Spanish)",
                        name: ["vendorSection", "benefit", "exhibitBooth", "eventNameES"],
                        rules: []
                    },
                    placeholder: "Please input event name es",
                    type: "text",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Event Prize Name",
                        name: ["vendorSection", "benefit", "exhibitBooth", "eventPriceName"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please input event prize name",
                    type: "textarea",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Event Prize Name (Spanish)",
                        name: ["vendorSection", "benefit", "exhibitBooth", "eventPriceNameES"],
                        rules: []
                    },
                    placeholder: "Please input event prize name es",
                    type: "textarea",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Event prize picture",
                        name: ["vendorSection", "benefit", "exhibitBooth", "eventGiftPicture"],
                        rules: []
                    },
                    required: true,
                    setting: {
                        accept: "image/png, image/jpeg",
                        max: 3,
                        size: 5 * 1024 * 1024,
                        listType: "picture",
                        supportText: "Supported upload format - Png & Jpeg",
                    },
                    type: "upload-multiple",
                }];
            }
        },
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        label: "Asset Types (please select all that apply):",
        type: "divider"
    },
    {
        col: { span: 24 },
        form: {
            label: "Logo required?",
            name: ["vendorSection", "benefit", "logoRequired", "answer"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Printed Materials",
            name: ["vendorSection", "benefit", "printedMaterials", "answer"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        subForm: {
            onRender: (value) => {
                if (!value) return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Language",
                        name: ["vendorSection", "benefit", "printedMaterials", "language"],
                        initialValue: "English",
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select languages.",
                    options: [
                        { label: "English", value: "English" },
                        { label: "Spanish", value: "Spanish" },
                        { label: "Bilingual", value: "Bilingual" },
                    ],
                    type: "select"
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Width - (If you are not sure of the width, you can enter NA).",
                        rules: []
                    },
                    primaryForm: {
                        form: {
                            name: ["vendorSection", "benefit", "printedMaterials", "width"],
                            rules: [{ required: true, message: "" }],
                        },
                        placeholder: "Please provide width.",
                        type: "text",
                    },
                    prefixForm: {
                        form: {
                            name: ["vendorSection", "benefit", "printedMaterials", "widthUnit"],
                            initialValue: "Inches",
                            rules: [],
                        },
                        options: [
                            { label: "Inches", value: "Inches" },
                            { label: "Pixel", value: "Pixel" }
                        ],
                        type: "select",
                    },
                    required: true,
                    type: "composite-input",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Height - (If you are not sure of the height, you can enter NA).",
                        rules: []
                    },
                    primaryForm: {
                        form: {
                            name: ["vendorSection", "benefit", "printedMaterials", "height"],
                            rules: [{ required: true, message: "" }],
                        },
                        placeholder: "Please provide height.",
                        type: "text",
                    },
                    prefixForm: {
                        form: {
                            name: ["vendorSection", "benefit", "printedMaterials", "heightUnit"],
                            initialValue: "Inches",
                            rules: [],
                        },
                        options: [
                            { label: "Inches", value: "Inches" },
                            { label: "Pixel", value: "Pixel" }
                        ],
                        type: "select",
                    },
                    required: true,
                    type: "composite-input",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Aspect Ratio (If you are not sure of the aspect ratio, you can enter NA)",
                        name: ["vendorSection", "benefit", "printedMaterials", "aspectRatio"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please provide aspect ratio.",
                    type: "text",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Black and White or Color",
                        name: ["vendorSection", "benefit", "printedMaterials", "colorOrBw"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select Black and White or color.",
                    options: [
                        { label: "BW", value: "BW" },
                        { label: "Color", value: "Color" },
                    ],
                    type: "select",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Bleed border",
                        name: ["vendorSection", "benefit", "printedMaterials", "bleedBorder"],
                        rules: []
                    },
                    options: [
                        { label: "Yes", value: true },
                        { label: "No", value: false },
                    ],
                    required: true,
                    type: "radio",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Due Date",
                        name: ["vendorSection", "benefit", "printedMaterials", "dueDate"],
                        rules: []
                    },
                    bottomTitle: {
                        onShowBottom: () => {
                            return <div className="mt-2">Please allow at least 14 days for all creative requests.</div>
                        }
                    },
                    inputProps: {
                        disabledDate: (current) => {
                            return current && current < dayjs().add(14, "day").startOf("day");
                        },
                    },
                    required: true,
                    placeholder: "Due Date",
                    type: "date",
                }];
            }
        },
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Digital Advertising",
            name: ["vendorSection", "benefit", "digitalAdvertising", "answer"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        subForm: {
            onRender: (value) => {
                if (!value) return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Language",
                        name: ["vendorSection", "benefit", "digitalAdvertising", "language"],
                        initialValue: "English",
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select languages.",
                    options: [
                        { label: "English", value: "English" },
                        { label: "Spanish", value: "Spanish" },
                        { label: "Bilingual", value: "Bilingual" },
                    ],
                    type: "select"
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Width - (If you are not sure of the width, you can enter NA).",
                        rules: []
                    },
                    primaryForm: {
                        form: {
                            name: ["vendorSection", "benefit", "digitalAdvertising", "width"],
                            rules: [
                                { required: true, message: "" }
                            ],
                        },
                        type: "text",
                        placeholder: "Please provide width.",
                    },
                    prefixForm: {
                        form: {
                            name: ["vendorSection", "benefit", "digitalAdvertising", "widthUnit"],
                            initialValue: "Inches",
                            rules: [],
                        },
                        options: [
                            { label: "Inches", value: "Inches" },
                            { label: "Pixel", value: "Pixel" }
                        ],
                        type: "select",
                    },
                    required: true,
                    type: "composite-input",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Height - (If you are not sure of the height, you can enter NA).",
                        rules: []
                    },
                    primaryForm: {
                        form: {
                            name: ["vendorSection", "benefit", "digitalAdvertising", "height"],
                            rules: [{ required: true, message: "" }],
                        },
                        type: "text",
                        placeholder: "Please provide height.",
                    },
                    prefixForm: {
                        form: {
                            name: ["vendorSection", "benefit", "digitalAdvertising", "heightUnit"],
                            initialValue: "Inches",
                            rules: [],
                        },
                        options: [
                            { label: "Inches", value: "Inches" },
                            { label: "Pixel", value: "Pixel" }
                        ],
                        type: "select",
                    },
                    required: true,
                    type: "composite-input",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Aspect Ratio (If you are not sure of the aspect ratio, you can enter NA)",
                        name: ["vendorSection", "benefit", "digitalAdvertising", "aspectRatio"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please provide aspect ratio.",
                    type: "text",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Black and White or Color",
                        name: ["vendorSection", "benefit", "digitalAdvertising", "colorOrBw"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select Black and White or color.",
                    options: [
                        { label: "BW", value: "BW" },
                        { label: "Color", value: "Color" },
                    ],
                    type: "select",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Format (png, jpeg, eps)",
                        name: ["vendorSection", "benefit", "digitalAdvertising", "format"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select Format.",
                    options: [
                        { label: "png", value: "png" },
                        { label: "jpeg", value: "jpeg" },
                        { label: "eps", value: "eps" },
                    ],
                    type: "select",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Due Date",
                        name: ["vendorSection", "benefit", "digitalAdvertising", "dueDate"],
                        rules: []
                    },
                    bottomTitle: {
                        onShowBottom: () => {
                            return <div className="mt-2">Please allow at least 14 days for all creative requests.</div>
                        }
                    },
                    inputProps: {
                        disabledDate: (current) => {
                            return current && current < dayjs().add(14, "day").startOf("day");
                        },
                    },
                    required: true,
                    placeholder: "Due Date",
                    type: "date",
                }];
            }
        },
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Video Media",
            name: ["vendorSection", "benefit", "videoMedia", "answer"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        subForm: {
            onRender: (value) => {
                if (!value) return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Language",
                        name: ["vendorSection", "benefit", "videoMedia", "language"],
                        initialValue: "English",
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select languages.",
                    options: [
                        { label: "English", value: "English" },
                        { label: "Spanish", value: "Spanish" },
                        { label: "Bilingual", value: "Bilingual" },
                    ],
                    type: "select"
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Start Date",
                        name: ["vendorSection", "benefit", "videoMedia", "startDate"],
                        rules: []
                    },
                    inputProps: {
                        disabledDate: (current, dependenciesFieldValue) => {
                            if (current && dependenciesFieldValue && current > dependenciesFieldValue.startOf("day")) {
                                return true;
                            }

                            return current && current < dayjs().add(14, "day").startOf("day");
                        },

                    },
                    dependenciesField: {
                        key: ["vendorSection", "benefit", "videoMedia", "endDate"],
                    },
                    required: true,
                    placeholder: "Start Date",
                    type: "date",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "End Date",
                        name: ["vendorSection", "benefit", "videoMedia", "endDate"],
                        rules: []
                    },
                    inputProps: {
                        disabledDate: (current, dependenciesFieldValue) => {
                            if (current && dependenciesFieldValue && current < dependenciesFieldValue.startOf("day")) {
                                return true;
                            }

                            return current && current < dayjs().add(14, "day").startOf("day");
                        },
                    },
                    dependenciesField: {
                        key: ["vendorSection", "benefit", "videoMedia", "startDate"],
                    },
                    required: true,
                    placeholder: "End Date",
                    type: "date",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Vendor station / channel",
                        name: ["vendorSection", "benefit", "videoMedia", "vendorType"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please input vendor station / channel.",
                    type: "text",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Durations",
                        name: ["vendorSection", "benefit", "videoMedia", "duration"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select durations",
                    options: [
                        { label: "6 seconds", value: 6 },
                        { label: "15 seconds", value: 15 },
                        { label: "30 seconds", value: 30 },
                    ],
                    type: "select",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Format (mp4, mov)",
                        name: ["vendorSection", "benefit", "videoMedia", "format"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select Format.",
                    options: [
                        { label: "mp4", value: "mp4" },
                        { label: "mov", value: "mov" },
                    ],
                    type: "select",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Due Date",
                        name: ["vendorSection", "benefit", "videoMedia", "dueDate"],
                        rules: []
                    },
                    bottomTitle: {
                        onShowBottom: () => {
                            return <div className="mt-2">Please allow at least 14 days for all creative requests.</div>
                        }
                    },
                    inputProps: {
                        disabledDate: (current) => {
                            return current && current < dayjs().add(14, "day").startOf("day");
                        },
                    },
                    required: true,
                    placeholder: "Due Date",
                    type: "date",
                }];
            }
        },
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Audio Media",
            name: ["vendorSection", "benefit", "audioMedia", "answer"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        subForm: {
            onRender: (value) => {
                if (!value) return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Language",
                        name: ["vendorSection", "benefit", "audioMedia", "language"],
                        initialValue: "English",
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select languages.",
                    options: [
                        { label: "English", value: "English" },
                        { label: "Spanish", value: "Spanish" },
                        { label: "Bilingual", value: "Bilingual" },
                    ],
                    type: "select"
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Start Date",
                        name: ["vendorSection", "benefit", "audioMedia", "startDate"],
                        rules: []
                    },
                    inputProps: {
                        disabledDate: (current, dependenciesFieldValue) => {
                            if (current && dependenciesFieldValue && current > dependenciesFieldValue.startOf("day")) {
                                return true;
                            }

                            return current && current < dayjs().add(14, "day").startOf("day");
                        },
                    },
                    dependenciesField: {
                        key: ["vendorSection", "benefit", "audioMedia", "endDate"],
                    },
                    required: true,
                    placeholder: "Start Date",
                    type: "date",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "End Date",
                        name: ["vendorSection", "benefit", "audioMedia", "endDate"],
                        rules: []
                    },
                    inputProps: {
                        disabledDate: (current, dependenciesFieldValue) => {
                            if (current && dependenciesFieldValue && current < dependenciesFieldValue.startOf("day")) {
                                return true;
                            }

                            return current && current < dayjs().add(14, "day").startOf("day");
                        },
                    },
                    dependenciesField: {
                        key: ["vendorSection", "benefit", "audioMedia", "startDate"],
                    },
                    required: true,
                    placeholder: "End Date",
                    type: "date",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Vendor station / channel",
                        name: ["vendorSection", "benefit", "audioMedia", "vendorType"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please input vendor station / channel.",
                    type: "text",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Durations",
                        name: ["vendorSection", "benefit", "audioMedia", "duration"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select durations",
                    options: [
                        { label: "6 seconds", value: 6 },
                        { label: "15 seconds", value: 15 },
                        { label: "30 seconds", value: 30 },
                    ],
                    type: "select",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Format (mp3, wav)",
                        name: ["vendorSection", "benefit", "audioMedia", "format"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select Format.",
                    options: [
                        { label: "mp3", value: "mp3" },
                        { label: "wav", value: "wav" },
                    ],
                    type: "select",
                }];
            }
        },
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "CSL Plasma Branded Signage",
            name: ["vendorSection", "benefit", "brandedSignage", "answer"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        subForm: {
            onRender: (value) => {
                if (!value) return [];

                return [{
                    col: { span: 24 },
                    form: {
                        label: "Language",
                        name: ["vendorSection", "benefit", "brandedSignage", "language"],
                        initialValue: "English",
                        rules: []
                    },
                    required: true,
                    placeholder: "Please select languages.",
                    options: [
                        { label: "English", value: "English" },
                        { label: "Spanish", value: "Spanish" },
                        { label: "Bilingual", value: "Bilingual" },
                    ],
                    type: "select"
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Describe",
                        name: ["vendorSection", "benefit", "brandedSignage", "description"],
                        rules: []
                    },
                    required: true,
                    placeholder: "Please describe it in detail",
                    type: "textarea",
                }, {
                    col: { span: 24 },
                    form: {
                        label: "Due Date",
                        name: ["vendorSection", "benefit", "brandedSignage", "dueDate"],
                        rules: []
                    },
                    bottomTitle: {
                        onShowBottom: () => {
                            return <div className="mt-2">Please allow at least 14 days for all creative requests.</div>
                        }
                    },
                    inputProps: {
                        disabledDate: (current, dependenciesFieldValue) => {
                            return current && current < dayjs().add(14, "day").startOf("day");
                        },
                    },
                    required: true,
                    placeholder: "Due Date",
                    type: "date",
                }];
            }
        },
        required: true,
        type: "radio",
    },
    {
        col: { span: 24 },
        form: {
            label: "Do you need a Lead Generation Form populated?",
            name: ["vendorSection", "leadGenerationFormPopulated"],
            rules: []
        },
        options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
        ],
        type: "radio",
    },
    {
        col: { span: 24 },
        label: "Contract and design documents can be uploaded here for your request",
        type: "divider"
    },
    {
        col: { span: 24 },
        form: {
            label: "",
            name: ["contractAndDesignDocuments", "uploadedDocuments"],
            rules: []
        },
        required: true,
        setting: {
            max: 3,
            size: 10 * 1024 * 1024,
            supportText: "Supported upload format - Word & PDF",
            accept: ".doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf"
        },
        type: "upload-multiple",
    }
];